<template>
	<div class="c-brands-empty">
		<div class="c-brands-empty__inner">
			<strong>Track competitor brands</strong>
			<article class="article-text-sm">
				<p>
					Track brands from the Facebook ad library and Swipekit will save their
					latest ads and generate insights for you.
				</p>
				<br />
				<button
					type="button"
					@click.prevent="onAddBrand"
					class="btn btn-primary"
				>
					Track brand
				</button>
			</article>
		</div>
	</div>
</template>

<script>
export default {
	methods: {
		onAddBrand: function () {
			this.$store.dispatch('app/setAddBrand', true);
		},
	},
};
</script>

<style lang="scss">
.c-brands-empty {
	position: relative;
	width: 100%;
	display: flex;
	justify-content: center;
	align-items: center;
	text-align: center;

	&__inner {
		display: inline-block;
		margin: 0 auto;
		border-radius: 10px;
		padding: var(--spacer-sm) var(--spacer);

		width: calc(var(--header-width));
		margin: var(--spacer-sm) auto;

		h2 {
			font-size: var(--font-size-xl);
			line-height: 1.4;
		}

		p {
			margin-bottom: 0;
		}

		ul {
			text-align: left;
		}
	}
}
</style>
